module.exports = __webpack_public_path__ + "static/img/tel.d204d41.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/index/tel.png
// module id = 9bLj
// module chunks = 0